import React, { useEffect } from "react";
import ReactQuill from "react-quill";
import EditorToolbar, { modules, formats } from "./EditorToolbar";
import "react-quill/dist/quill.snow.css";
// import "./styles.css";

export const Editor = ({ content, onContentChange }) => {

  const [state, setState] = React.useState({ value: content });
  useEffect(() => {
    setState({ value: content });
  }, [content]);
  const handleChange = value => {
    setState({ value });

    if (onContentChange) {
        onContentChange(value);
      }
  };
  return (
    <div className="text-editor">
      <EditorToolbar />
      <ReactQuill
        theme="snow"
        value={state.value}
        onChange={handleChange}
        placeholder={"Write something awesome..."}
        modules={modules}
        formats={formats}
      />
    </div>
  );
};

export default Editor;
